/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  checkWhatsAppContact({ accountId, contactId, inboxId }) {
    return axios.get(`/api/v1/accounts/${accountId}/conversations/whatsapp_check`, {
      params: { contact_id: contactId, inbox_id: inboxId }
    });
  }
}

export default new ConversationApi();
